import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, Dictionary, ReadonlyHttpApiListRepository } from '@softline/core';
import { SOFTLINE_API_TASKS } from '../workflow.api';

@Injectable()
export class TasksRepository extends ReadonlyHttpApiListRepository<any, any> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_TASKS);
  }

  protected override getLoadQueryParams(params: any): Dictionary<unknown> | undefined {
    return params;
  }
}
